/**
 * Features that MySerbisyo turns off (spec 001, contracts/features.md).
 *
 * Each one only works in Australia, or depends on a partner MySerbisyo does not use. They are
 * switched off here rather than deleted, because SWMS alone touches 15 files of the job screens,
 * and the partners may want the subscription back. Constants, not settings: no company can turn
 * one on.
 */
export const FEATURES = {
  /** Xero accounting sync. No Xero demand in the Philippines. */
  xero: false,
  /** SWMS and high-risk construction work. Australian work-health-and-safety law. */
  swms: false,
  /** Stripe Terminal, Tap to Pay on iPhone. Built on Australian Stripe. */
  tapToPay: false,
  /** Australian payroll export (KeyPay, Xero Payroll). */
  payrollExport: false,
  /** The subscription trial and lock-out. The commission is the only charge at launch. */
  paywall: false,
  /** Card payments, deposits and Stripe Connect. Escrow (spec 008) replaces them. */
  stripePayments: false,
  /** A country picker. MySerbisyo serves the Philippines only. */
  countryChoice: false,
} as const

export type FeatureKey = keyof typeof FEATURES
